import { ProgramEnrollmentStatus } from '@sandtech-hub-monorepo/ehub-client';

const STATUS_ORDER: ProgramEnrollmentStatus[] = [
  ProgramEnrollmentStatus.Ongoing,
  // Paused enrollments are still active study, just interrupted, so they sit
  // with ongoing rather than at the end. Listed explicitly because an unlisted
  // status would get indexOf === -1 and sort ahead of everything.
  ProgramEnrollmentStatus.LeaveOfAbsence,
  ProgramEnrollmentStatus.Deferred,
  ProgramEnrollmentStatus.Pending,
  ProgramEnrollmentStatus.Graduated,
];

/**
 * Drops failed enrollments and returns the rest sorted with ongoing first,
 * then pending, then graduated. The backend doesn't guarantee ordering, so
 * the sort is needed for a stable UI on every render.
 */
export const getDisplayableEnrollments = <
  T extends { status: ProgramEnrollmentStatus }
>(
  enrollments: readonly T[]
): T[] =>
  enrollments
    .filter((e) => e.status !== ProgramEnrollmentStatus.Failed)
    .slice()
    .sort(
      (a, b) => STATUS_ORDER.indexOf(a.status) - STATUS_ORDER.indexOf(b.status)
    );
